import { HStack, IconButton, Text } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';

import { useActivityDetail } from '../../../hooks/use-activity-detail';
import { EditableColumnProps } from '../../../types/activity-column-types';

interface Props extends EditableColumnProps<BackofficeActivitiesOrderItem, string | null | undefined> {
  activitiesId: string;
  token?: string;
  refetch: () => void;
  cancelReasonData: { label: string; value: string }[];
}

export function CancelReasonColumn({
  info,
  selectedData,
  onUpdate,
  activitiesId,
  token,
  refetch,
  cancelReasonData,
}: Props) {
  const [value, setValue] = useState<string>();
  const [deleteData, setDeleteData] = useState<boolean>(false);
  const { handlePatchData } = useActivityDetail({
    selectedData,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setSelectedData: () => {},
    refetch,
    activitiesId,
    token,
  });

  const isSelected = selectedData.some((row) => row.original.id === info.row.original.id);

  useEffect(() => {
    if (value) {
      onUpdate(value, info.row.original.id);
      handlePatchData({ cancel_reason_id: value }, '', `${activitiesId}/item/${info.row.original.id}`);
    }
    if (deleteData) {
      onUpdate(null, info.row.original.id);
      handlePatchData({ cancel_reason_id: null }, '', `${activitiesId}/item/${info.row.original.id}`);
    }
  }, [value, deleteData]);

  if (isSelected) {
    return (
      <HStack>
        <select
          name="cancel_reason_id"
          id="cancel_reason_id"
          style={{
            padding: '4px',
            borderWidth: '1px',
            borderColor: 'grey',
            borderRadius: '4px',
            background: 'white',
          }}
          onChange={(e) => setValue(e.target.value)}
          defaultValue={info.getValue() ?? ''}
        >
          {cancelReasonData.map((value, index) => {
            return (
              <option value={value.value} key={index}>
                {value.label}
              </option>
            );
          })}
        </select>
        <IconButton
          aria-label="x"
          size="xs"
          p="2px"
          icon={<CloseIcon />}
          onClick={() => {
            setValue('');
            setDeleteData(true);
          }}
        />
      </HStack>
    );
  }

  const cancelReason = cancelReasonData.filter((reason) => reason.value === info.getValue());
  return <Text fontSize="sm" fontWeight="400" color="#373F41">{cancelReason[0] ? cancelReason[0].label : '-'}</Text>;
}
